import React from 'react';

interface Props {
  size: string;
  color: string;
}

export const Edit = ({ size, color }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.47522 10.2792C3.48627 10.2355 3.50893 10.1956 3.54079 10.1638L12.4671 1.23744C12.5648 1.13981 12.7231 1.13981 12.8207 1.23744L14.7626 3.17931C14.8602 3.27694 14.8602 3.43523 14.7626 3.53286L5.83622 12.4592C5.80436 12.4911 5.76448 12.5137 5.7208 12.5248L3.12065 13.1831C2.93705 13.2296 2.77045 13.063 2.81694 12.8794L3.47522 10.2792Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <line x1="3.50211" y1="10.1418" x2="5.60119" y2="12.2409" stroke={color} />
  </svg>
);

export default Edit;
